export function switchPixelsColor(canvas, fromRGB, toRGB) {
  const ctx = canvas.getContext("2d");

  const { width, height } = canvas;
  const { r: srcR, g: srcG, b: srcB } = fromRGB;
  const { r: dstR, g: dstG, b: dstB } = toRGB;

  const im = ctx.getImageData(0, 0, width, height);
  for (let i = 0; i < im.data.length; i += 4) {
    if (
      im.data[i] === srcR &&
      im.data[i + 1] === srcG &&
      im.data[i + 2] === srcB
    ) {
      im.data[i] = dstR;
      im.data[i + 1] = dstG;
      im.data[i + 2] = dstB;
    }
  }
  ctx.putImageData(im, 0, 0);
}

/**
 * Expands 3-char hex to 6-char (e.g. #fff → #ffffff).
 * Use for user-facing display in panels; keep short hex in code/CSS.
 */
export function expandHexTo6(hex) {
  if (!hex || typeof hex !== "string") return hex;
  const raw = (hex.hex || hex).replace(/^#/, "").toUpperCase();
  if (raw.length === 3) {
    return "#" + raw.split("").map((c) => c + c).join("");
  }
  return raw.length === 6 ? "#" + raw : hex;
}

export function hexToRgb(hex) {
  // Remove the '#' character, if present
  hex = hex.replace(/^#/, "");

  // Parse the hexadecimal value to an integer
  const intValue = parseInt(hex, 16);

  // Extract the red, green, and blue components
  const red = (intValue >> 16) & 255;
  const green = (intValue >> 8) & 255;
  const blue = intValue & 255;

  // Return the RGB color as an object
  return {
    r: red,
    g: green,
    b: blue,
  };
}
